import { Modal } from "@/components";
import { QuizDto } from "@/types";
import { useState } from "react";
import { MdClose } from "react-icons/md";
import { QuizCard } from "./QuizCard";
import { QuizDetail } from "./QuizDetail";
import React from "react";

interface Props {
  quiz: QuizDto;
  onClose?: () => void;
  trigger?: React.ReactElement<{ onClick?: () => void }>;
}

export const QuizModal = ({ quiz, onClose, trigger }: Props) => {
  const { id, title, image, isDone } = quiz;
  const [open, setOpen] = useState(false);

  const openModal = () => {
    setOpen(true);
  };

  const closeModal = () => {
    setOpen(false);
  };

  return (
    <>
      {trigger ? (
        React.isValidElement(trigger) ? (
          React.cloneElement(trigger, {
            onClick: () => openModal(),
          })
        ) : null
      ) : (
        <div onClick={openModal}>
          <QuizCard id={id} title={title} coverImage={image} isDone={isDone} />
        </div>
      )}
      {open && (
        <Modal
          open={open}
          onOpenChange={setOpen}
          fullScreen
          overflowScroll={true}
          className="bg-grey-200"
          title={
            <div className="flex gap-2 items-center">
              <button onClick={closeModal}>
                <MdClose className="size-6 text-action_light_active" />
              </button>
              テスト詳細
            </div>
          }
        >
          <QuizDetail
            quiz={quiz}
            closeModal={() => {
              closeModal();
              onClose?.();
            }}
          />
        </Modal>
      )}
    </>
  );
};
